import { render, staticRenderFns } from "./pcGrowup.vue?vue&type=template&id=50636cb5&scoped=true&"
import script from "./pcGrowup.vue?vue&type=script&lang=js&"
export * from "./pcGrowup.vue?vue&type=script&lang=js&"
import style0 from "./pcGrowup.vue?vue&type=style&index=0&id=50636cb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50636cb5",
  null
  
)

export default component.exports